import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class ItinerariesApi extends Api {
  constructor() {
    super('website/itineraries/');
  }

  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  create = (data) => {
    const formData = new FormData();

    if (data.title_it || data.title) {
      formData.append('itinerary[title_it]', data.title_it || data.title);
    }
    if (data.description_it || data.description) {
      formData.append('itinerary[description_it]', data.description_it || data.description);
    }
    if (data.description_short_it || data.description_short) {
      formData.append('itinerary[description_short_it]', data.description_short_it || data.description_short);
    }
    if (data.shopping_center_id) {
      formData.append('itinerary[shopping_center_id]', data.shopping_center_id);
    }
    if (data.image) {
      formData.append('itinerary[image]', data.image);
    }

    if (data.title_en) formData.append('itinerary[title_en]', data.title_en);
    if (data.title_fr) formData.append('itinerary[title_fr]', data.title_fr);
    if (data.description_en) formData.append('itinerary[description_en]', data.description_en);
    if (data.description_fr) formData.append('itinerary[description_fr]', data.description_fr);
    if (data.description_short_en) formData.append('itinerary[description_short_en]', data.description_short_en);
    if (data.description_short_fr) formData.append('itinerary[description_short_fr]', data.description_short_fr);

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/itineraries`,
      method: 'POST',
      data: formData,
      headers: { 'auth-token': AuthService.getToken() },
    });
  };

  update = (id, data) => {
    const formData = new FormData();

    if (data.title_it || data.title) {
      formData.append('itinerary[title_it]', data.title_it || data.title);
    }
    if (data.description_it || data.description) {
      formData.append('itinerary[description_it]', data.description_it || data.description);
    }
    if (data.description_short_it || data.description_short) {
      formData.append('itinerary[description_short_it]', data.description_short_it || data.description_short);
    }
    if (data.shopping_center_id) {
      formData.append('itinerary[shopping_center_id]', data.shopping_center_id);
    }
    if (data.image) {
      formData.append('itinerary[image]', data.image);
    }

    if (data.title_en) formData.append('itinerary[title_en]', data.title_en);
    if (data.title_fr) formData.append('itinerary[title_fr]', data.title_fr);
    if (data.description_en) formData.append('itinerary[description_en]', data.description_en);
    if (data.description_fr) formData.append('itinerary[description_fr]', data.description_fr);
    if (data.description_short_en) formData.append('itinerary[description_short_en]', data.description_short_en);
    if (data.description_short_fr) formData.append('itinerary[description_short_fr]', data.description_short_fr);

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/itineraries/${id}`,
      method: 'PUT',
      data: formData,
      headers: { 'auth-token': AuthService.getToken() },
    });
  };

  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/itineraries/${id}`,
      method: 'DELETE',
      headers: { 'auth-token': AuthService.getToken() },
    });
  };

  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new ItinerariesApi();



